import { render, staticRenderFns } from "./OverseasBanksForm.vue?vue&type=template&id=7fe220e6&scoped=true&"
import script from "./OverseasBanksForm.vue?vue&type=script&lang=js&"
export * from "./OverseasBanksForm.vue?vue&type=script&lang=js&"
import style0 from "./OverseasBanksForm.vue?vue&type=style&index=0&id=7fe220e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe220e6",
  null
  
)

export default component.exports